'use strict';

import { Entity } from '../Entity';

export class UserCallLogSummary extends Entity {
  protected id;

  protected callLog;

  protected reference;

  protected summary;

  protected suggestions;

  protected rawPayload;

  protected sentiment;

  protected topics;

  protected dateTimeCreated;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.callLog = data.callLog;

    this.reference = data.reference;

    this.summary = data.summary;

    this.suggestions = data.suggestions;

    this.rawPayload = data.rawPayload;

    this.sentiment = data.sentiment;

    this.topics = data.topics;

    this.dateTimeCreated = data.dateTimeCreated;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getCallLog() {
    return this.callLog;
  }

  public setCallLog(callLog) {
    this.callLog = callLog;

    return this;
  }

  public getReference() {
    return this.reference;
  }

  public setReference(reference) {
    this.reference = reference;

    return this;
  }

  public getSummary() {
    return this.summary;
  }

  public setSummary(summary) {
    this.summary = summary;

    return this;
  }

  public getSuggestions() {
    return this.suggestions;
  }

  public setSuggestions(suggestions) {
    this.suggestions = suggestions;

    return this;
  }

  public getRawPayload() {
    return this.rawPayload;
  }

  public setRawPayload(rawPayload) {
    this.rawPayload = rawPayload;

    return this;
  }

  public getSentiment() {
    return this.sentiment;
  }

  public setSentiment(sentiment) {
    this.sentiment = sentiment;

    return this;
  }

  public getTopics() {
    return this.topics;
  }

  public setTopics(topics) {
    this.topics = topics;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }
}
